/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { Pagination, Spin, Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';
import Accordion from '../../components/accordion';
import Bread from '../../components/breadcrumb';
import Card from '../../components/card';
import { routeGrafica } from '../../utils/routesBread';
import { columnsGraficas, parserDataTabla } from '../../utils/parsers/table';
import { usePagination } from '../../hooks/usePagination';
import { fetchGrafica } from '../../actions/grafica';
import Button from '../../components/button';
import { CREAR_GRAFICA_PATH } from '../../routes/path';
import { parserGrafica } from '../../utils/parsers/grafica';
import SankeyGraphTab from './sankey-tab';

const Grafica = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('graficas-tradicionales');
  const {
    dataSource, total, handlePage, page, isLoading
  } = usePagination(fetchGrafica, 'grafica');

  const renderGraficasTradicionales = () => (
    <Accordion keyPanel="graficas" header="Gráficas">
      {isLoading
        ? (
          <div className="container-spin">
            <Spin tip="Cargando..." />
          </div>
        )
        : (
          <>
            {dataSource && dataSource.length !== 0 ? (
              dataSource.map((item) => (
                <div key={item._id}>
                  <Card
                    columns={columnsGraficas(item)}
                    data={[parserDataTabla(parserGrafica(item))]}
                    header={item.nombre}
                    route="info-grafica"
                  />
                </div>
              ))
            ) : <p className="text-nothing">No hay datos para mostrar</p>}
          </>
        )}
    </Accordion>
  );

  const tabItems = [
    {
      key: 'graficas-tradicionales',
      label: 'Gráficas Tradicionales',
      children: renderGraficasTradicionales()
    },
    {
      key: 'graficas-sankey',
      label: 'Gráficas Sankey',
      children: <SankeyGraphTab />
    }
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="page-container">
      <div className="header-nav">
        <Bread routes={routeGrafica} />
        {activeTab === 'graficas-tradicionales' && (
          <Button
            type="button"
            text="Crear Gráfica"
            onClick={() => navigate(CREAR_GRAFICA_PATH)}
            color="gray"
          />
        )}
      </div>
      <div className="page-container__box">
        <Tabs 
          activeKey={activeTab}
          onChange={handleTabChange}
          items={tabItems}
          size="large"
          style={{ marginBottom: '1rem' }}
        />
        
        {/* Pagination solo para gráficas tradicionales */}
        {activeTab === 'graficas-tradicionales' && dataSource && (
          <div className="page-container__pagination">
            <Pagination current={page} onChange={handlePage} total={total} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Grafica;